import { apiFetch } from './api'

export type StaffRole = 'ADMIN' | 'OPERATOR'

export interface StaffDto {
  id: string
  mobile: string
  name: string
  role: StaffRole
  isActive: boolean
  lastLoginAt: string | null
  createdAt: string
}

export interface StaffAuthResponse {
  accessToken: string
  staff: StaffDto
}

export const ROLE_LABEL: Record<StaffRole, string> = {
  ADMIN: 'مدیر',
  OPERATOR: 'اپراتور',
}

export const requestCode = (mobile: string) =>
  apiFetch<{ expiresIn: number; retryAfter: number; devCode?: string }>('/admin/auth/otp/request', {
    method: 'POST',
    body: { mobile },
    retryOnUnauthorized: false,
  })

export const verifyCode = (mobile: string, code: string) =>
  apiFetch<StaffAuthResponse>('/admin/auth/otp/verify', {
    method: 'POST',
    body: { mobile, code },
    retryOnUnauthorized: false,
  })

export const listStaff = () => apiFetch<StaffDto[]>('/admin/staff')

export const createStaff = (body: { mobile: string; name: string; role: StaffRole }) =>
  apiFetch<StaffDto>('/admin/staff', { method: 'POST', body })

export const updateStaff = (
  id: string,
  body: Partial<Pick<StaffDto, 'name' | 'role' | 'isActive'>>,
) => apiFetch<StaffDto>(`/admin/staff/${id}`, { method: 'PATCH', body })
